import React from "react";
import styled from "styled-components";
import {Link} from "react-scroll";
import {Home, Mail, MapPin} from "react-feather";


export const ContainerMenuHearder = styled.header`
    position: fixed;
    height: 50px;
    display: flex;
    justify-content: space-between;
    width: 95%;
    top: 0;
    left: 5px;
    color: black;
    text-align: center;
    justify-items: center;
    align-items: center;
    margin-left: 14px;
    
    span{
    display: flex;
    font-size: 12px;
    margin: 20px;
    width: 70px;
    justify-content: space-between;
    }
      
`;
export const Wrapper = styled.div`
    color: white;
    opacity: 0.7;
    :hover {
           opacity: 1;
           transform: scale(1.1);
           color: white;
        } 
`;

export const MenuHearder = () => {
    return (
        <ContainerMenuHearder>
            <Link
                to={'home'}
                activeClass="active"
                spy={true}
                smooth={true}
                offset={0}
                duration={500}
            >
                <Wrapper></Wrapper>
            </Link>
            <span>
                    <Link
                        to={'endereco'}
                        activeClass="active"
                        spy={true}
                        smooth={true}
                        offset={0}
                        duration={500}
                    >
                        <Wrapper><MapPin/></Wrapper>
                    </Link>

                 <Link
                     to={'contato'}
                     activeClass="active"
                     spy={true}
                     smooth={true}
                     offset={0}
                     duration={500}
                 >
                 <Wrapper><Mail/></Wrapper>
                 </Link>
            </span>
        </ContainerMenuHearder>
    )
};